import React from 'react';
import './Footer.css';

function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-top">
                    <a className="footer-wordmark" href="/">это Россия</a>
                    <nav className="footer-nav" aria-label="Навигация в подвале">
                        <a href="#products">Коллекция</a>
                        <a href="#fit">Как сидит</a>
                        <a href="#about">О бренде</a>
                        <a href="#contacts">Контакты</a>
                    </nav>
                </div>
                <div className="footer-bottom">
                    <p className="footer-text">© {year} ЭТО РОССИЯ</p>
                    <a href="https://t.me/itismyrussia" rel="noopener noreferrer">@itismyrussia</a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
